import api from './api';

const DEFAULT_MEMBERSHIP_PLANS = [
  { id: 'pool-basic', programType: 'Pool', displayName: 'Havuz 1 Aylık', price: 0, creditCount: 1, isActive: true, sortOrder: 1, isFallback: true },
  { id: 'fitness-basic', programType: 'Fitness', displayName: 'Fitness 1 Aylık', price: 0, creditCount: 1, isActive: true, sortOrder: 1, isFallback: true }
];

export const applyForCard = async (data) => {
  return await api.post('/api/card/apply', data);
};

export const getCardApplications = async () => {
  return await api.get('/api/card/applications');
};

export const assignCardNumber = async (data) => {
  return await api.post('/api/card/assign-number', data);
};

export const loadBalance = async (data) => {
  return await api.post('/api/card/load-balance', data);
};

export const getCardTransactions = async () => {
  return await api.get('/api/card/transactions');
};

export const getCardPaymentHistory = async () => {
  return await api.get('/api/card/payment-history');
};

export const getCardBalance = async (cardNumber) => {
  return await api.get(`/api/card/balance/${cardNumber}`);
};

export const getFitnessBalance = async (identityNumber, phone) => {
  return await api.post('/api/card/balance-by-identity', { identityNumber, phone });
};

export const getMembershipPlans = async (programType = null) => {
  const params = {};
  if (programType) params.programType = programType;
  try {
    return await api.get('/api/card/membership-plans', { params });
  } catch (error) {
    if (error?.response?.status === 404) {
      const filtered = programType
        ? DEFAULT_MEMBERSHIP_PLANS.filter((plan) => plan.programType === programType)
        : DEFAULT_MEMBERSHIP_PLANS;
      return {
        isSuccess: true,
        data: filtered,
        resultMessage: 'Membership plans endpoint not available; fallback data returned.'
      };
    }
    throw error;
  }
};

export const updateMembershipPlans = async (plans) => {
  return await api.put('/api/card/membership-plans', { plans });
};

export const getCardPendingLoads = async () => {
  return await api.get('/api/card/pending-loads');
};

export const markCardTransactionLoaded = async (transactionId) => {
  return await api.put(`/api/card/transactions/${transactionId}/mark-loaded`);
};

export const getWomenTrainingApplications = async () => {
  return await api.get('/api/women-training/applications');
};
